import { AxiosClient } from '@/app/common/services/http/axios-client.service'
import store from '@/plugins/store'
import { GetMaintenanceCommand } from '@/app/maintenance/commands/get-maintenance.command'

const httpClient = new AxiosClient()

export const getMaintenanceCommand = new GetMaintenanceCommand(httpClient, store)
